import { Container, Nav, Navbar, Offcanvas } from "react-bootstrap";
import { FormInput } from "../../../components/forms";
import { LoadingToggler } from "../../../components/loaders";
import { useClientSetContext } from "../hooks/ClientSetContext";
import classNames from "classnames";

const ClientSetNavbar = () => {
    const {
        selectedSetId,
        showSetOptions,
        setShowSetOptions,
        clientSetOptions,
        searchTerm,
        setSearchTerm
    } = useClientSetContext();

    return <Navbar className="d-flex w-100 border-bottom py-2" variant="light" expand={false}>
        <Container fluid>
            <FormInput
                placeholder="Search for a Master Account"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                disableAnimations
            />
            <LoadingToggler
                className="ms-auto"
                enabledText="Client Set Options"
                onClick={() => setShowSetOptions(!showSetOptions)}
            />
            <Navbar.Offcanvas placement="end" show={showSetOptions} onHide={() => setShowSetOptions(false)}>
                <Offcanvas.Header closeButton={selectedSetId != null}>
                    <Offcanvas.Title>Client Set Options</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {clientSetOptions.map((option, index) => (
                        <Nav.Link key={index} className={classNames("text-start text-muted", { "d-none": option.hidden })} onClick={option.onClick}>
                            {option.label}
                        </Nav.Link>
                    ))}
                </Offcanvas.Body>
            </Navbar.Offcanvas>

        </Container>
    </Navbar>;
}

export default ClientSetNavbar;